import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { request } from '../../axios';

export interface CreateCaseFormValues {
    caseNumber: string | null;
    personId: string | null;
}

export interface CreateCasePayload {
    caseNumber: string | null;
    personId: string | null;
}

export function createCase(payload: CreateCasePayload) {
    return request<string>({
        url: '/api/patients',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: payload,
    });
}

export function useCreateCaseMutation(
    options?: UseMutationOptions<string, Error, CreateCasePayload>,
) {
    return useMutation({
        mutationFn: createCase,
        ...options,
    });
}